import { Link } from "react-router-dom";
import CarFees from "../../Assests/imgs/page/homepage2/moneyfees.png";
import CarMiles from "../../Assests/imgs/page/homepage2/unlimitedMiles.png";
import CarMechanic from "../../Assests/imgs/page/homepage2/mechanicCar.png";

export default function FeaturesSection() {
  return (
    <section className="section-cta-4 position-relative overflow-hidden">
      <div className="bg-shape"></div>
      <div className="container position-relative z-1">
        {/* <div className="text-center">
          <span className="text-sm-bold bg-white p-3 rounded-12 wow fadeInDown">
            Best Car Rental System
          </span>
          <h4 className="mt-4 wow fadeInUp">
            Receive a Competitive Offer <br />
            Sell Your Car to Us Today. Get a Car on Lease Today <br />
            Easy and Convenient!
          </h4>
        </div> */}
        <div className="row mt-60 ">
          <div className="col-lg-4 mb-4">
            <div className="bg-white rounded-12 p-5 d-flex justify-content-center align-items-center flex-column gap-4 borderTopNew">
              <span className="icon-shape icon_150 rounded-circle wow fadeIn">
                <img
                  className="dark-invert"
                  loading="lazy"
                  src={CarFees}
                  title="No Hidden Fees"
                  alt="Rapid Cars"
                />
              </span>
              <h6 className="wow fadeInUp">No Hidden Fees</h6>
              <p className="text-md-regular text-center wow fadeInUp">
                Transparent pricing with no extra fees. Enjoy an all-inclusive
                car rental for Lyft drivers with insurance, maintenance and
                support are included in your all-inclusive rental.
              </p>
            </div>
          </div>
          <div className="col-lg-4 mb-4">
            <div className="bg-white h-100 rounded-12 p-5 d-flex justify-content-center align-items-center flex-column gap-4 borderTopNew">
              <span className="icon-shape icon_150  rounded-circle wow fadeIn">
                <img
                  className="dark-invert"
                  loading="lazy"
                  src={CarMiles}
                  title="Unlimited Local Miles"
                  alt="Rapid Cars"
                />
              </span>
              <h6 className="wow fadeInUp">Unlimited Local Miles</h6>
              <p className="text-md-regular text-center wow fadeInUp">
                Drive as you please! If you are looking to rent a car for Uber
                or Lyft with no mileage limits to earn big, this profile is
                perfect for you.
              </p>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="bg-white rounded-12 p-5 d-flex justify-content-center align-items-center flex-column gap-4 borderTopNew">
              <span className="icon-shape icon_150  rounded-circle wow fadeIn">
                <img
                  className="dark-invert"
                  src={CarMechanic}
                  alt="Rapid Cars"
                  title="Mechanic Approved"
                  loading="lazy"
                />
              </span>
              <h6 className="wow fadeInUp">Mechanic Approved</h6>
              <p className="text-md-regular text-center wow fadeInUp">
                Our cars are always checked and inspected for the best
                performance. Be safe and assured that your rideshare Chicago
                trip will be in a well-maintained vehicle that is ready for your
                use.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
